import { useEffect, useRef } from "react";
import { List } from "react-virtualized";
import {
  IMAGES_PANEL_MASONRY_FAKE_CELLS,
  IMAGES_PANEL_MASONRY_GAPS,
  IMAGES_PANEL_SKELETON_HEIGHTS,
} from "../../constants";
import type { IImagesPanelImage } from "../../types";
import { ImagesPanelStockMasonryRow } from "./stock-masonry-row";

const HEIGHTS = IMAGES_PANEL_SKELETON_HEIGHTS;
const GAPS = IMAGES_PANEL_MASONRY_GAPS;

interface IProps {
  scrollTop: number;
  colWidth: number;
  height: number;
  images: IImagesPanelImage[];
  colIdx: number;
  onLoadMore?: () => void;
}

export const ImagesPanelStockMasonryColumn = ({
  images,
  scrollTop,
  colWidth,
  height,
  onLoadMore,
  colIdx,
}: IProps) => {
  const listRef = useRef<List | null>(null);

  useEffect(() => {
    if (!listRef.current) return;
    listRef.current.recomputeRowHeights();
  }, [colWidth, images]);

  return (
    <List
      ref={listRef}
      onRowsRendered={
        onLoadMore
          ? (data) => {
              if (
                data.startIndex >=
                  images.length - IMAGES_PANEL_MASONRY_FAKE_CELLS ||
                data.stopIndex >=
                  images.length - IMAGES_PANEL_MASONRY_FAKE_CELLS
              ) {
                onLoadMore();
              }
            }
          : undefined
      }
      autoHeight
      scrollTop={scrollTop}
      width={colWidth}
      overscanRowCount={10}
      height={height}
      rowCount={images.length + IMAGES_PANEL_MASONRY_FAKE_CELLS}
      className="!tw-overflow-visible [&>div]:!tw-overflow-visible"
      rowHeight={({ index }) => {
        const data = images[index];
        if (!data) {
          return (
            HEIGHTS[colIdx % HEIGHTS.length][index % HEIGHTS.length] + GAPS
          );
        }
        const height = colWidth * (data.height / data.width) || 67;
        return height + GAPS;
      }}
      rowRenderer={(rowData) => (
        <ImagesPanelStockMasonryRow
          key={rowData.key}
          rowData={rowData}
          imageData={images[rowData.index]}
        />
      )}
    />
  );
};
